import {
  BrowserModule,
  provideClientHydration,
} from '@angular/platform-browser';
import { APP_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  //HttpClientModule,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataTablesModule } from 'angular-datatables';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgxMaskDirective, provideNgxMask, NgxMaskPipe } from 'ngx-mask';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import {
  BsDatepickerModule,
  BsLocaleService,
  BsDatepickerConfig,
} from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { Routes, RouterModule } from '@angular/router';
import { RoutingComponent } from './shared/routing/routing.component';
import { PropertyListingComponent } from './property-listing/property-listing.component';
import { PropertyListViewComponent } from './property-listing/property-list-view/property-list-view.component';
import { PropertySearchComponent } from './property-listing/property-search/property-search.component';
import { PropertyCardComponent } from './property-listing/property-card/property-card.component';
import { DatePipe } from '@angular/common';
import { PropertyMapViewComponent } from './property-listing/map-view/map-view.component';
import { MapSearchListComponent } from './property-listing/map-search-list/map-search-list.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { ViewPropertyComponent } from './property/property-view.component';
import { OfferComponent } from './property-listing/place-offer/offer.component';
import { LightboxModule } from 'ngx-lightbox';
import { BrokerageManagerService } from './shared/providers/brokerage-manager.service';
import { HomeService } from './shared/providers/home.service';
import { ComparisonService } from './shared/providers/comparison.service';
import { FileUploadService } from './shared/providers/fileupload.service';
import { UserManagerService } from './shared/providers/user-manager.service';
import { AuthService } from './shared/auth/auth.service';
import { PropertyDashboardComponent } from './property/property-dashboard/property-dashboard.component';
import { ProspectsComponent } from './property/property-dashboard/prospects/prospects.component';
import { DashboardService } from './shared/providers/dashboard.service';
import { ExternalMarketingListComponent } from './property/property-dashboard/external-marketing-list/external-marketing-list.component';
import { ExternalMaketingAddComponent } from './property/property-dashboard/external-maketing-add/external-maketing-add.component';
import { DealContactsComponent } from './property/property-dashboard/deal-contacts/deal-contacts.component';
// import { NgxCurrencyModule } from "ngx-currency";
import { AccordionModule } from 'ngx-bootstrap/accordion';
//import { ChartModule, HIGHCHARTS_MODULES } from 'angular-highcharts';
//import { Dashboard1031Component } from './1031-exchange/1031-dashboard/1031-dashboard.component';
// Pipes
import { SharedPipesModule } from './shared/shared-pipes/shared-pipes.module';
import { FileComponent } from './property/property-dashboard/file/file.component';
import { OfferFilesTabComponent } from './offers/offer-details/offer-files-tab/offer-files-tab.component';
import { OfferService } from './shared/providers/offer.service';
import { PropertyRevisionsAddComponent } from './property/property-revisions/property-revisions-add/property-revisions-add.component';
import { PropertyRevisonListComponent } from './property/property-revisions/property-revison-list/property-revison-list.component';
import { SaleHistoryDetailComponent } from './property/property-revisions/property-revison-list/sale-history-detail/sale-history-detail.component';
import { PropertyCompsComponent } from './property/property-comps/property-comps.component';
import { SaleHistoryListComponent } from './property/property-comps/sale-history-list/sale-history-list.component';
import { SharedPropertyRevisionModule } from './shared/shared-components/shared-property-revision/shared-property-revision.module';
import { SharedModule } from './shared/shared.module';
import { ProspectsListComponent } from './property/property-dashboard/prospects-list/prospects-list.component';
import { DashboardComponent } from './property/property-dashboard/dashboard/dashboard.component';
import { BOVComponent } from './property/property-dashboard/BOV/bov.component';
import { BovPriceAnalysisComponent } from './property/property-dashboard/BOV/bov-price-analysis/bov-price-analysis.component';
import { BovReadyForReviewComponent } from './property/property-dashboard/BOV/bov-ready-for-review/bov-ready-for-review.component';
import { BOVInformationUploadComponent } from './property/property-dashboard/BOV/bovinformation-upload/bovinformation-upload.component';
import { PropertyPremarketingComponent } from './property/property-dashboard/property-premarketing/property-premarketing.component';
import { PropertyDealMakingComponent } from './property/property-dashboard/property-deal-making/property-deal-making.component';
import { PropertyOffersListComponent } from './property/property-offers-list.component';
import { AuthGuard } from './shared/auth/auth.guard.service';
import { UserRole } from '../app/shared/enum/enum';
import { OpportunityService } from './shared/providers/opportunity.service';
import { AddPropertyComponent } from './property/property-add.component';
import { RentTermTableComponent } from './property/rent-term-table/rent-term-table.component';
import { AuditTrailComponent } from './audit-trail/audit-trail.component';
import { SharedUserProfileModule } from './shared/shared-components/shared-user-profile/shared-user-profile.module';
import { MyPropertySearchComponent } from './my-property-listing/my-property-search.component';
import { MyPropertyListViewComponent } from './my-property-listing/my-property-listing.component';
import { ArchiveComponent } from './my-property-listing/archive/archive.component';
import { PropertyApprovalListComponent } from './admin/property-approval-list/property-approval-list.component';
import { UserDetailsComponent } from './user-details/user-details.component';
import { UserAddComponent } from './user-add/user-add.component';
import { PrincipalDetailsComponent } from './principal-details/principal-details.component';
import { InvitePrincipalComponent } from './user/invite-principal/invite-principal.component';
import { PrincipalEditComponent } from './principal-edit/principal-edit.component';
import { Inquiry1031Component } from './1031-inquiry/inquiry-1031.component';
import { My1031InquiryListComponent } from './1031-inquiry/my1031-inquiry-list/my1031-inquiry-list.component';
import { InquiryListComponent } from './opportunity/inquiry-details.component';
import { DocAccessListingComponent } from './doc-access-listing/doc-access-listing.component';
import { OffersListComponent } from './offers/offers-list/offers-list.component';
import { User1031ExchangeListComponent } from './1031-assignment/1031exchange-list.component';
import { AnalyticsService } from './shared/providers/analytics.service';
import { SharedListingModule } from './shared/shared-components/shared-listing/shared-listing.module';
import { SharedPropertiesModule } from './shared/shared-components/shared-properties/shared-properties.module';
import { ImportPropertyComponent } from './property/import/property-import-component';
import { PropertyImportService } from './shared/providers/property-import.service';
import { AnalyticsPageComponent } from './properties/analytics/analytics-page.component';
import { Dashboard1031Component } from './1031-exchange/1031-dashboard/1031-dashboard.component';
import { User1031PortfolioComponent } from './1031-exchange/1031-portfolio/1031-portfolio.component';
/*import { NgDragDropModule } from 'ng-drag-drop';*/
import { FinancialSummaryModule } from './shared/shared-components/financial-summary/financial-summary.module';
import { BrokerPropertiesComponent } from './property/broker-properties/broker-properties.component';
import { DealsListBuyComponent } from './offers/deals-list-buy/deals-list-buy.component';
import { SharedDealsModule } from './shared/shared-components/shared-deals/shared-deals.module';
import { MyInquiryListComponent } from './my-property-listing/my-inquiry-listing.component';
import { ToastrModule } from 'ngx-toastr';
import { PropertyListComponent } from './data-entry-staff/property-list/property-list.component';
import { AddDataEntryPropertyComponent } from './data-entry-staff/add-property/add-property.component';
import { DeViewPropertyComponent } from './data-entry-staff/de-view-property/de-view-property.component';
import { QuickEditPropertyComponent } from './data-entry-staff/property-list/quick-edit-property/quick-edit-property.component';
import { UserProfileEditComponent } from './profile-edit/profile-edit.component';
import { HighchartsChartModule } from 'highcharts-angular';
import * as more from 'highcharts-more';
import { OfferComparisonComponent } from './property/property-dashboard/dashboard/p-dashboard-charts/offer-comparison/offer-comparison.component';
import { PDashboardChartsComponent } from './property/property-dashboard/dashboard/p-dashboard-charts/p-dashboard-charts.component';
import { LeadsConversionComponent } from './property/property-dashboard/dashboard/p-dashboard-charts/leads-conversion/leads-conversion.component';
import { ProspectsAddComponent } from './property/property-dashboard/prospects-add/prospects-add.component';
import { TimeRemainingInfoComponent } from './1031-exchange/1031-dashboard/time-remaining-info/time-remaining-info.component';
import { OfferDetailLatestComponent } from './offers/offer-details/offer-detail-latest.component';
import { OfferDetailTabComponent } from './offers/offer-details/offer-detail-tab/offer-detail-tab.component';
import { OfferTaskListComponent } from './offers/offer-details/offer-task-list/offer-task-list.component';
import { OfferProgressTabComponent } from './offers/offer-details/offer-progress-tab/offer-progress-tab.component';
import { OfferExpenseListComponent } from './offers/offer-details/offer-expense-list/offer-expense-list.component';
import { OrderModule } from 'ngx-order-pipe';
import { OfferProgressChartComponent } from './offers/offer-details/offer-progress-chart/offer-progress-chart.component';
import { User1031RegistrationComponent } from './1031-registration/1031-registration.component';
import { Exchange1031ViewComponent } from './1031-exchange-view/1031-exchange-view.component';
import { PropertyComparison } from './1031-exchange/property-comparison/property-comparison.component';
import { Exchange1031InviteComponent } from './1031-exchange/1031-exchange-invite/exchange-1031-invite.component';
import { Exchange1031SuggestComponent } from './1031-exchange/1031-property-suggest/exchange-1031-suggest.component';
import { PortfolioPropertySuggestComponent } from './property/portfolio/portfolio-property-suggest/portfolio-property-suggest.component';
import { PortfolioPropertyListComponent } from './property/portfolio/portfolio-property-list/portfolio-property-list.component';
import { PortfolioPlaceOfferComponent } from './property/portfolio/portfolio-place-offer/portfolio-place-offer.component';
import { PlaceOfferComponent } from './property-listing/place-offer/place-offer.component';
import { OfferExchangeSelectorComponent } from './property-listing/place-offer/offer-exchange-selector/offer-exchange-selector.component';
import { ExternalBrokerSelectionComponent } from './property-listing/place-offer/external-broker-selection/external-broker-selection.component';
import { BrokerDetailsComponent } from './property/broker-details/broker-details.component';
import { PropertyBrokerageComponent } from './property/property-brokerage/property-brokerage.component';
import { SharedNotesModule } from './shared/shared-components/shared-notes/shared-notes.module';
import { SharePropertycomponent } from './property/ShareProperty/Share-Property.component';
import { TagInputModule } from 'ngx-chips';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { Shared404Component } from './404/shared404.component';
import { NgxSocialShareModule } from 'ngx-social-share';
import { CounterOfferComponent } from './offers/counter-offer/counter-offer.component';
import { OfferStatusChangeComponent } from './offers/offer-shared/offer-status-change/offer-status-change.component';
import { TooltipConfig, TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { MatchingListingsComponent } from './admin/property-approval-list/matching-listings/matching-listings.component';
import { BrokerageBrokerAddComponent } from './data-entry-staff/add-property/brokerage-broker-add/brokerage-broker-add.component';
import { SharedUsersModule } from './shared/shared-components/shared-users/shared-users.module';
import { BuyComponent } from './static-pages/buy/buy.component';
import { ContactUsComponent } from './static-pages/contact-us/contact-us.component';
import { Dashboard1031InitialComponent } from './1031-exchange/1031-dashboard-initial/dashboard-1031-initial.component';
import { Exchange1031ListComponent } from './1031-exchange/1031-exchange-list/exchange-1031-list.component';
import { AddFavoriteExchangeComponent } from './property-listing/add-favorite-exchange/add-favorite-exchange.component';
import { PortfolioAnalysisComponent } from './1031-exchange/portfolio-analysis/portfolio-analysis.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { LoginFormAuth0Component } from './login-form/login-form-auth0/login-form-auth0.component';
import { RegisterService } from './shared/providers/register.service';
import { ForgotPasswordService } from './shared/providers/forgot-password.service';
import { BraAcceptComponent } from './property-listing/bra-accept/bra-accept.component';
import { DuplicatePropertiesComponent } from './data-entry-staff/add-property/duplicate-properties/duplicate-properties.component';
import { PropertyDuplicatesComponent } from './property/property-duplicates/property-duplicates.component';
import { PropertyNotesComponent } from './property/property-notes/property-notes.component';
/*import { IntercomModule } from 'ng-intercom';*/
import { SellerListingsComponent } from './property/property-dashboard/seller-listings/seller-listings.component';
import { SharedTickerModule } from './shared/shared-components/shared-ticker/shared-ticker.module';
import { MastersModule } from './masters/masters.module';
import { SuggestMultiplePropertiesComponent } from './suggest-multiple-properties/suggest-multiple-properties.component';
import { SharedMasterModule } from './shared/shared-components/shared-master/shared-master.module';
import { OfferEditComponent } from './offers/offer-edit/offer-edit.component';
import { NdaAgreementComponent } from './property/nda-agreement/nda-agreement.component';
import { DdListComponent } from './property/dd-list/dd-list.component';
import { DueDilignenceListComponent } from './data-entry-staff/due-dilignence-list/due-dilignence-list.component';
import { PrincipalDashboardComponent } from './Principal/principal-dashboard/principal-dashboard.component';
import { WaitListUsersListComponent } from './Principal/wait-list-users-list/wait-list-users-list.component';
import { AddInterestCriteriaComponent } from './InterestCriteria/add-interest-criteria/add-interest-criteria.component';
import { InterestCriteriaListingComponent } from './InterestCriteria/InterestCriteriaListing/InterestCriteriaListing.component';
import { SellerLearnMoreComponent } from './Principal/seller-learn-more/seller-learn-more.component';
import { TradeLearnMoreComponent } from './Principal/trade-learn-more/trade-learn-more.component';
import { DataEntryDashboardComponent } from './data-entry-dashboard/data-entry-dashboard/data-entry-dashboard.component';
import { MarkettingDashboardComponent } from './MarkettingDashboard/marketting-dashboard.component';
import { AddUserToDDComponent } from './property/property-dashboard/add-user-to-dd/add-user-to-dd.component';
import { BuyerQuestionnaireComponent } from './Buyer-Questionnaire/Buyer-Questionnaire.component';
import { EditRentTermTableComponent } from './property/rent-term-table/edit-rent-term-table.component';
import { PropertyLeaseHistoryListComponent } from './property/property-comps/property-lease-history-list/property-lease-history-list.component';
import { AddMyportfolioPropertyComponent } from './MyPortfolio/add-new-property/add-new-property.component';
import { PortfloioPropertyListingComponent } from './MyPortfolio/property-listing/property-listing.component';
import { MarketSnapshotComponent } from './MyPortfolio/MarketSnapshot/market-snapshot.component';
import { PendingPortfolioProperties } from './MyPortfolio/MarketSnapshot/Pending-Properties/pending-portfolio-properties.component';
import { PortfolioWatchListComponent } from './MyPortfolio/MarketSnapshot/Watch-list/watch-list.component';
import { PropertyDetailsComponent } from './MyPortfolio/property-details/property-details.component';
import { PropertyDataComponent } from './MyPortfolio/property-details/Tabs/Property-Data/property-data.component';
import { MarketDataComponent } from './MyPortfolio/property-details/Tabs/Market-Data/market-data.component';
import { MyPortfolioProperties } from './MyPortfolio/MarketSnapshot/My-Properties/my-portfolio-properties.component';
import { MarketSnapshotChartComponent } from './MyPortfolio/MarketSnapshot/MarketSnapshotChart/Market-Snapshot-Chart.component';
import { CreditProfileSummaryComponent } from './MyPortfolio/property-details/Tabs/Credit-Profile/summary/credit-profile-summary.component';
import { CreditProfileStatisticsComponent } from './MyPortfolio/property-details/Tabs/Credit-Profile/statistics/credit-profile-statistics.component';
import { CreditProfileFinancialsComponent } from './MyPortfolio/property-details/Tabs/Credit-Profile/financials/credit-profile-financials.component';
import { CreditProfileProfileTabComponent } from './MyPortfolio/property-details/Tabs/Credit-Profile/profile-tab/credit-profile-profile.component';
import { CreditProfileComponent } from './MyPortfolio/property-details/Tabs/Credit-Profile/credit-profile.component';
import { PortfolioAnalysisTabComponent } from './MyPortfolio/PortfolioAnalysis/PortfolioAnalysisTab/Portfolio-Analysis-Tab.component';
import { MyPortfolioAnalysisComponent } from './MyPortfolio/PortfolioAnalysis/portfolio-analysis.component';
import { PortfolioAnalysisDetailComponent } from './MyPortfolio/PortfolioAnalysis/PortfolioAnalysisDetail/Portfolio-Analysis-Detail.component';
import { SavedAnalysisTabComponent } from './MyPortfolio/PortfolioAnalysis/SavedAnalysis/Saved-Analysis-Tab.component';
import { MyPortfolioAddLeasingHistoryComponent } from './MyPortfolio/property-details/Tabs/Property-History/add-leasing-history/my-portfolio-add-leasing-history.component';
import { MyPortfolioAddSalesHistoryComponent } from './MyPortfolio/property-details/Tabs/Property-History/add-sales-history/my-portfolio-add-sales-history.component';
import { MyPortfolioLeasingHistoryListComponent } from './MyPortfolio/property-details/Tabs/Property-History/leasing-history-list/my-portfolio-leasing-history-list.component';
import { MyPortfolioPropertyHistoryRentTermComponent } from './MyPortfolio/property-details/Tabs/Property-History/property-history-rent-term/my-portfolio-property-history-rent-term.component';
import { PropertyHistoryComponent } from './MyPortfolio/property-details/Tabs/Property-History/property-history.component';
import { MyPortfolioPropertyLeaseHistoryListComponent } from './MyPortfolio/property-details/Tabs/Property-History/property-lease-history-list/my-portfolio-property-lease-history-list.component';
import { MyPortfolioSaleHistoryListComponent } from './MyPortfolio/property-details/Tabs/Property-History/sale-history-list/my-portfolio-sale-history-list.component';
import { PortfolioFilesComponent } from './MyPortfolio/MarketSnapshot/Portfolio-Files/portfolio-files.component';
import { PortfolioFilesUploadComponent } from './MyPortfolio/MarketSnapshot/PortfolioFiles-Upload/PortfolioFiles-Upload.component';
import { MasterContactComponent } from './MyPortfolio/MasterContactList/master-contact.component';
import { PortfolioContactComponent } from './MyPortfolio/MasterContactList/PortfolioContacts/portfolio-contact.component';
import { PropertyContactComponent } from './MyPortfolio/MasterContactList/PropertyContacts/property-contact.component';
import { PortfolioMarkettingComponent } from './MyPortfolio/property-details/Tabs/Portfolio-Marketting/portfolio-marketting.component';
import { PortfolioApprovalListComponent } from './admin/portfolio-approval-list/portfolio-approval-list.component';
import { QuickEditMyPortfolioComponent } from './MyPortfolio/Quick-Edit-Portfolio/quick-edit-myportfolio.component';
import { DuediligenceComponent } from './MyPortfolio/property-details/Tabs/Due-Diligence/portfolio-duediligence-list.component';
import { ViewPortfolioComponent } from './admin/view-portfolio/view-portfolio.component';
import { PreferenceComponent } from './MyPortfolio/Preference/preference.component';
import { StandardUserAddComponent } from './MyPortfolio/Preference/standarduser-add/standarduser-add.component';
import { StandardUserDetailsComponent } from './MyPortfolio/Preference/standarduser-details/standarduser-details.component';
import { MyPortfolioSummaryComponent } from './MyPortfolio/MarketSnapshot/My-Portfolio-Summary/my-portfolio-summary.component';
import { AddMyportfolioPrincipalPropertyComponent } from './MyPortfolio/add-new-property/add-new-principal-property.component';
import { ImportProspects } from './property/property-dashboard/Import-Prospects/import-prospects-add.component';
import { ProspectDetailsComponent } from './prospect-details/prospect-details.component';
import { NoAccessPageComponent } from './NOAccessPage/no-access-page.component';
import { ShareOMDocumentscomponent } from './shared-om-users/Share-OMDocuments.component';
import { SortPreview } from './property/property-dashboard/dashboard/sortpreview/sort-preview';
import { ProspectPreview } from './property/property-dashboard/dashboard/sortpreview/prospect-preview/prospect-preview';
import { PropertyOfferDocumentUpload } from './property/property-offer-document-upload.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxCurrencyDirective } from 'ngx-currency';
import {
  CdkDrag,
  CdkDropList,
  CdkDropListGroup,
  DragDropModule,
} from '@angular/cdk/drag-drop';
import { MatSelectModule } from '@angular/material/select';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { MatCheckboxModule, MAT_CHECKBOX_DEFAULT_OPTIONS } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SoldDetailsComponent } from './property/sold-details/sold-details.component';
import { PropertyHistoryRentTermComponent } from './property/property-comps/property-history-rent-term/property-history-rent-term.component';
import { AddSalesHistoryComponent } from './property/property-comps/add-sales-history/add-sales-history.component';
import { AddLeasingHistoryComponent } from './property/property-comps/add-leasing-history/add-leasing-history.component';
import { AddConfidentialityAgreementComponent } from './property/property-dashboard/add-confidentiality-Agreement/add-confidentiality-Agreement.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { UserAssociationsComponent } from './user-associations/user-associations.component';
import { UserExchangesComponent } from './user-exchanges/user-exchanges.component';
import { UserOffersComponent } from './user-offers/user-offers.component';
import { DESAssociationsComponent } from './des-associations/des-associations.component';
import { UsersNotificationsComponent } from './users-notifications/users-notifications.component';
import { RolePermissionsComponent } from './role-permissions/role-permissions.component';
import { PermissionService } from './shared/providers/permission.service';
import { Actions, Modules } from './shared/enum/enum';

export function getDatepickerConfig(): BsDatepickerConfig {
  return Object.assign(new BsDatepickerConfig(), {
    containerClass: 'theme-green',
    showWeekNumbers: false,
  });
}
export function highchartsModules() {
  // apply Highcharts Modules to this array
  return [more];
}
const routes: Routes = [
  {
    path: 'InterestCriteriaListing',
    component: InterestCriteriaListingComponent,
    canActivate: [AuthGuard],
    data: {
      moduleId: Modules.BuyerCriteria,
      actionId: Actions.Listings
    },
  },
  {
    path: 'MarketingDashboard',
    component: MarkettingDashboardComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.Broker, UserRole.SuperAdmin] },
  },
  {
    path: 'BuyerQuestionnaire',
    component: BuyerQuestionnaireComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.Broker, UserRole.SuperAdmin] },
  },
  { path: '', component: PropertyListingComponent },
  { path: 'home', component: PropertyListingComponent },
  { path: 'buy', component: PropertyListingComponent },
  { path: 'viewproperty/:id', component: ViewPropertyComponent },
  {
    path: 'viewdeproperty/:id',
    component: DeViewPropertyComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.DataEntryStaff, UserRole.SuperAdmin] },
  },
  { path: 'propertylisting', component: PropertyListingComponent },
  { path: 'redirect', component: RoutingComponent },
  {
    path: 'property',
    component: AddPropertyComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.DataEntryStaff, UserRole.SuperAdmin] },
  },
  {
    path: 'property/:id',
    component: AddPropertyComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.DataEntryStaff, UserRole.SuperAdmin] },
  },
  // { path: 'masters', loadChildren: './masters/masters.module#MastersModule', canActivate: [AuthGuard], data: { roles: [UserRole.Admin, UserRole.Broker] } }
  {
    path: 'masters',
    //loadChildren: './masters/masters.module#MastersModule',
    loadChildren: () =>
      import('./masters/masters.module').then((m) => m.MastersModule),
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.Broker, UserRole.SuperAdmin, UserRole.DataEntryStaff] },
  },
  {
    path: 'audit-trail',
    loadChildren: () =>
      import(
        './shared/shared-components/shared-user-profile/shared-user-profile.module'
      ).then((m) => m.SharedUserProfileModule),
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.Broker, UserRole.SuperAdmin] },
  },

  {
    path: 'my-profile',
    loadChildren: () =>
      import(
        './shared/shared-components/shared-user-profile/shared-user-profile.module'
      ).then((m) => m.SharedUserProfileModule),
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.Broker, UserRole.SuperAdmin] },
  },
  {
    path: 'my-property-view',
    component: MyPropertyListViewComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.Broker, UserRole.SuperAdmin] },
  },
  {
    path: 'archive-view',
    component: ArchiveComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.Broker, UserRole.SuperAdmin] },
  },
  {
    path: 'pending-approval-list',
    component: PropertyApprovalListComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.SuperAdmin] },
  },
  {
    path: 'offmarket-approval-list',
    component: PortfolioApprovalListComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.SuperAdmin] },
  },
  {
    path: 'view-portfolio',
    component: ViewPortfolioComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.SuperAdmin] },
  },
  {
    path: 'properties',
    loadChildren: () =>
      import('./properties/properties.module').then((m) => m.PropertiesModule),
  },
  {
    path: 'employees',
    loadChildren: () =>
      import('./employee/employee.module').then((m) => m.EmployeeModule),
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.Broker, UserRole.SuperAdmin, UserRole.DataEntryStaff] },
  },
  {
    path: 'employee-details',
    component: UserDetailsComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [UserRole.Admin, UserRole.Broker, UserRole.SuperAdmin, UserRole.DataEntryStaff],
      moduleId: Modules.Employees,
      actionId: Actions.Details
    },
  },
  {
    path: 'employee-add',
    component: UserAddComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [UserRole.Admin, UserRole.Broker, UserRole.SuperAdmin, UserRole.DataEntryStaff],
      moduleId: Modules.Employees,
      actionId: Actions.Create
    },
  },
  {
    path: 'employee-edit',
    component: UserAddComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [UserRole.Admin, UserRole.Broker, UserRole.SuperAdmin, UserRole.DataEntryStaff],
      moduleId: Modules.Employees,
      actionId: Actions.Edit
    },
  },
  {
    path: 'users',
    loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.Broker, UserRole.SuperAdmin, UserRole.DataEntryStaff] },
  },
  {
    path: 'comps',
    loadChildren: () =>
      import('./comps/comps.module').then((m) => m.CompsModule),
  },
  {
    path: 'registered-user-details',
    component: PrincipalDetailsComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [UserRole.Admin, UserRole.Broker, UserRole.SuperAdmin, UserRole.DataEntryStaff],
      moduleId: Modules.ExternalUsers,
      actionId: Actions.Details
    },
  },
  {
    path: 'registered-user-edit',
    component: PrincipalEditComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [UserRole.Admin, UserRole.Broker, UserRole.SuperAdmin, UserRole.DataEntryStaff],
      moduleId: Modules.ExternalUsers,
      actionId: Actions.Edit
    },
  },
  {
    path: '1031-inquiry',
    component: Inquiry1031Component,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.SuperAdmin] },
  },
  {
    path: 'inquiry-list',
    component: InquiryListComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.Broker, UserRole.SuperAdmin] },
  },
  {
    path: 'docaccesslist',
    component: DocAccessListingComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.Broker, UserRole.SuperAdmin] },
  },
  {
    path: 'offers-list',
    component: OffersListComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.Broker, UserRole.SuperAdmin] },
  },
  {
    path: 'bov',
    loadChildren: () => import('./bov/bov.module').then((m) => m.BovModule),
  },
  {
    path: 'my-properties',
    component: MyPropertyListViewComponent,
    canActivate: [AuthGuard],
    data: { roles: null },
  },
  {
    path: 'archives',
    component: ArchiveComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.SuperAdmin] },
  },
  {
    path: '1031-exchanges',
    component: User1031ExchangeListComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        UserRole.Admin,
        UserRole.Broker,
        UserRole.Principal,
        UserRole.Principal1031,
        UserRole.ExternalBroker,
       UserRole.SuperAdmin
      ],
    },
  },
  {
    path: 'dashboard-1031/:id',
    component: Dashboard1031Component,
    canActivate: [AuthGuard],
    data: {
      roles: [null, UserRole.Admin, UserRole.Broker, UserRole.Principal1031, UserRole.SuperAdmin],
    },
  },
  {
    path: 'dashboard-1031',
    component: Dashboard1031Component,
    canActivate: [AuthGuard],
    data: {
      roles: [null, UserRole.Admin, UserRole.Broker, UserRole.Principal1031, UserRole.SuperAdmin],
    },
  },
  { path: '1031-registration', component: User1031RegistrationComponent, canActivate: [AuthGuard] },
  { path: '1031-registration/:id', component: User1031RegistrationComponent, canActivate: [AuthGuard] },
  {
    path: 'exchange1031-view/:id',
    component: Exchange1031ViewComponent,
    canActivate: [AuthGuard],
    data: { roles: null },
  },
  {
    path: 'notification',
    loadChildren: () =>
      import('./notification/notification.module').then(
        (m) => m.NotificationModule
      ),
    canActivate: [AuthGuard],
    data: {
      roles: [
        UserRole.Admin,
        UserRole.DataEntryStaff,
        UserRole.Broker,
        UserRole.Principal,
        UserRole.SuperAdmin
      ],
    },
  },
  {
    path: 'data-entry-staff',
    loadChildren: () =>
      import('./data-entry-staff/data-entry-staff.module').then(
        (m) => m.DataEntryStaffModule
      ),
    canActivate: [AuthGuard],
    data: { roles: [UserRole.DataEntryStaff] },
  },
  {
    path: 'principal-dashboard',
    component: PrincipalDashboardComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Principal, UserRole.Principal1031] },
  },
  {
    path: 'waitlist-users',
    component: WaitListUsersListComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.SuperAdmin] },
  },
  {
    path: 'propertyimport',
    component: ImportPropertyComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.SuperAdmin] },
  },
  {
    path: 'analytics',
    component: AnalyticsPageComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.Broker, UserRole.SuperAdmin] },
  },
  {
    path: 'data-entry-dashboard',
    component: DataEntryDashboardComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.SuperAdmin] },
  },
  {
    path: 'portfolio-1031',
    component: User1031PortfolioComponent,
    canActivate: [AuthGuard],
    data: { roles: null },
  },
  {
    path: 'placed-offers',
    component: MyPropertyListViewComponent,
    canActivate: [AuthGuard],
    data: { roles: null },
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [AuthGuard],
    data: { roles: null },
  },
  {
    path: 'my-listings',
    component: BrokerPropertiesComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Broker] },
  },
  {
    path: 'offers-placed',
    component: DealsListBuyComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Broker] },
  },
  {
    path: 'seller',
    loadChildren: () =>
      import('./seller/seller.module').then((m) => m.SellerModule),
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Seller, UserRole.Admin, UserRole.Broker, UserRole.SuperAdmin] },
  },
  {
    path: 'finance',
    loadChildren: () =>
      import('./seller/seller.module').then((m) => m.SellerModule),
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Seller, UserRole.Principal, UserRole.Principal1031, UserRole.Admin, UserRole.SuperAdmin] },
  },
  {
    path: 'deals-buy',
    component: DealsListBuyComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Principal1031, UserRole.ExternalBroker] },
  },
  {
    path: 'my-inquiries',
    component: MyInquiryListComponent,
    canActivate: [AuthGuard],
    data: { roles: null },
  },
  {
    path: 'share',
    loadChildren: () =>
      import('./shared/shared.module').then((m) => m.SharedModule),
  },
  {
    path: 'shared',
    loadChildren: () =>
      import('./share-listings/share-listings.module').then(
        (m) => m.ShareListingsModule
      ),
  },
  {
    path: 'favourite',
    component: PropertyListingComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        UserRole.Principal,
        UserRole.Principal1031,
        UserRole.ExternalBroker,
      ],
    },
  },
  {
    path: 'dislike',
    component: PropertyListingComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        UserRole.Principal,
        UserRole.Principal1031,
        UserRole.ExternalBroker,
      ],
    },
  },
  { path: 'property-listing', component: PropertyListComponent },
  {
    path: 'dataentry-property/:id',
    component: AddDataEntryPropertyComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.DataEntryStaff, UserRole.SuperAdmin] },
  },
  {
    path: 'dataentry-property',
    component: AddDataEntryPropertyComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.DataEntryStaff, UserRole.SuperAdmin] },
  },
  {
    path: 'role-permissions',
    component: RolePermissionsComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.SuperAdmin] },
  },
  {
    path: 'edit-profile',
    component: UserProfileEditComponent,
    canActivate: [AuthGuard],
    data: { roles: null },
  },
  {
    path: 'offer-detail/:id',
    component: OfferDetailLatestComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        UserRole.Admin,
        UserRole.Broker,
        UserRole.Principal,
        UserRole.Principal1031,
        UserRole.ExternalBroker,
        UserRole.SuperAdmin
      ],
    },
    runGuardsAndResolvers: 'always',
  },
  { path: 'counter-offer/:id', component: CounterOfferComponent },
  {
    path: 'merge',
    loadChildren: () =>
      import('./property-merge/property-merge.module').then(
        (m) => m.PropertyMergeModule
      ),
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Admin, UserRole.SuperAdmin] },
  },
  {
    path: 'saved-search',
    component: PropertyListingComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        UserRole.Principal,
        UserRole.Principal1031,
        UserRole.ExternalBroker,
        UserRole.Broker,
      ],
    },
  },
  {
    path: 'dashboard-1031-preview',
    component: Dashboard1031InitialComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        UserRole.Principal,
        UserRole.Principal1031,
        UserRole.ExternalBroker,
      ],
    },
  },
  {
    path: 'compare/:analyzeId',
    component: PropertyComparison,
    canActivate: [AuthGuard],
    data: { roles: null },
  },

  {
    path: 'place-offer/:id/:offerGuid/:fromPage',
    component: OfferComponent,
    canActivate: [AuthGuard],
    data: { roles: null },
  },
  {
    path: 'portfolio-property/:id',
    component: AddMyportfolioPropertyComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [UserRole.Admin, UserRole.Principal, UserRole.Principal1031, UserRole.SuperAdmin],
    },
  },
  {
    path: 'portfolio-property',
    component: AddMyportfolioPropertyComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [UserRole.Admin, UserRole.Principal, UserRole.Principal1031, UserRole.SuperAdmin],
    },
  },
  {
    path: 'portfolio-principal-property',
    component: AddMyportfolioPrincipalPropertyComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [UserRole.Admin, UserRole.Principal, UserRole.Principal1031, UserRole.SuperAdmin],
    },
  },
  {
    path: 'portfolio-principal-property/:id',
    component: AddMyportfolioPrincipalPropertyComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [UserRole.Admin, UserRole.Principal, UserRole.Principal1031, UserRole.SuperAdmin],
    },
  },
  {
    path: 'portfolio-propertyListing',
    component: PortfloioPropertyListingComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        UserRole.Principal,
        UserRole.Principal1031,
        UserRole.DataEntryStaff,
      ],
    },
  },
  {
    path: 'market-snapshot',
    component: MarketSnapshotComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [UserRole.Admin, UserRole.Principal, UserRole.Principal1031, UserRole.SuperAdmin],
    },
  },
  {
    path: 'property-detail/:id',
    component: PropertyDetailsComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [UserRole.Admin, UserRole.Principal, UserRole.Principal1031, UserRole.SuperAdmin],
    },
  },
  {
    path: 'watch-list',
    component: PortfolioWatchListComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [UserRole.Admin, UserRole.Principal, UserRole.Principal1031, UserRole.SuperAdmin],
    },
  },
  {
    path: 'market-snapshot/:analyzeId',
    component: MarketSnapshotComponent,
    canActivate: [AuthGuard],
    data: { roles: null },
  },
  {
    path: 'standarduser-add',
    component: StandardUserAddComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [UserRole.Principal, UserRole.Principal1031, UserRole.Admin, UserRole.SuperAdmin],
    },
  },
  {
    path: 'app-preference',
    component: PreferenceComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Principal, UserRole.Principal1031] },
  },
  {
    path: 'standarduser-detail',
    component: StandardUserDetailsComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [UserRole.Principal, UserRole.Principal1031, UserRole.Admin, UserRole.SuperAdmin],
    },
  },
  {
    path: 'prospect-detail',
    component: ProspectDetailsComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [UserRole.Broker, UserRole.Admin, UserRole.SuperAdmin, UserRole.DataEntryStaff],
      moduleId: Modules.Prospects,
      actionId: Actions.Details
    },
  },
  {
    path: 'prospect-detail/:prospectId',
    component: ProspectDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: [UserRole.Broker, UserRole.Admin, UserRole.SuperAdmin] },
  },
  { path: 'property-file-download', component: NoAccessPageComponent },
  { path: '**', component: Shared404Component },
];
@NgModule({
  declarations: [
    AppComponent,
    PropertyListViewComponent,
    PropertyListingComponent,
    PropertySearchComponent,
    PropertyCardComponent,
    PropertyMapViewComponent,
    MapSearchListComponent,
    MapSearchListComponent,
    HeaderComponent,
    FooterComponent,
    ViewPropertyComponent,
    OfferComponent,
    PropertyDashboardComponent,
    ProspectsComponent,
    ExternalMarketingListComponent,
    ExternalMaketingAddComponent,
    DealContactsComponent,
    FileComponent,
    OfferFilesTabComponent,
    PropertyRevisonListComponent,
    SaleHistoryDetailComponent,
    PropertyCompsComponent,
    SaleHistoryListComponent,
    PropertyLeaseHistoryListComponent,
    ProspectsListComponent,
    DashboardComponent,
    BOVComponent,
    BovPriceAnalysisComponent,
    BovReadyForReviewComponent,
    BOVInformationUploadComponent,
    PropertyPremarketingComponent,
    PropertyDealMakingComponent,
    PropertyOffersListComponent,
    NdaAgreementComponent,
    RoutingComponent,
    AddPropertyComponent,
    RentTermTableComponent,
    MyPropertyListViewComponent,
    MyPropertySearchComponent,
    ArchiveComponent,
    PropertyApprovalListComponent,
    UserDetailsComponent,
    UserAddComponent,
    PrincipalDetailsComponent,
    PrincipalEditComponent,
    Inquiry1031Component,
    My1031InquiryListComponent,
    InquiryListComponent,
    DocAccessListingComponent,
    OffersListComponent,
    User1031ExchangeListComponent,
    Dashboard1031Component,
    User1031PortfolioComponent,
    ImportPropertyComponent,
    AnalyticsPageComponent,
    BrokerPropertiesComponent,
    DealsListBuyComponent,
    MyInquiryListComponent,
    PropertyListComponent,
    AddDataEntryPropertyComponent,
    AddMyportfolioPropertyComponent,
    DeViewPropertyComponent,
    QuickEditPropertyComponent,
    UserProfileEditComponent,
    OfferComparisonComponent,
    PDashboardChartsComponent,
    LeadsConversionComponent,
    ProspectsAddComponent,
    TimeRemainingInfoComponent,
    OfferDetailLatestComponent,
    OfferDetailTabComponent,
    OfferTaskListComponent,
    OfferProgressTabComponent,
    OfferExpenseListComponent,
    OfferProgressChartComponent,
    User1031RegistrationComponent,
    Exchange1031ViewComponent,
    PropertyComparison,
    Exchange1031InviteComponent,
    Exchange1031SuggestComponent,
    PortfolioPropertySuggestComponent,
    PortfolioPropertyListComponent,
    PortfolioPlaceOfferComponent,
    PlaceOfferComponent,
    OfferExchangeSelectorComponent,
    ExternalBrokerSelectionComponent,
    BrokerDetailsComponent,
    PropertyBrokerageComponent,
    SharePropertycomponent,
    Shared404Component,
    CounterOfferComponent,
    OfferStatusChangeComponent,
    MatchingListingsComponent,
    BrokerageBrokerAddComponent,
    BuyComponent,
    ContactUsComponent,
    Exchange1031ListComponent,
    AddFavoriteExchangeComponent,
    PortfolioAnalysisComponent,
    LoginFormComponent,
    LoginFormAuth0Component,
    BraAcceptComponent,
    DuplicatePropertiesComponent,
    PropertyDuplicatesComponent,
    PropertyNotesComponent,
    SellerListingsComponent,
    InvitePrincipalComponent,
    SuggestMultiplePropertiesComponent,
    OfferEditComponent,
    DdListComponent,
    NdaAgreementComponent,
    DueDilignenceListComponent,
    PrincipalDashboardComponent,
    WaitListUsersListComponent,
    /* AddInterestCriteriaComponent,*/
    InterestCriteriaListingComponent,
    SellerLearnMoreComponent,
    TradeLearnMoreComponent,
    DataEntryDashboardComponent,
    MarkettingDashboardComponent,
    AddUserToDDComponent,
    BuyerQuestionnaireComponent,
    EditRentTermTableComponent,
    PortfloioPropertyListingComponent,
    MarketSnapshotComponent,
    PendingPortfolioProperties,
    PortfolioWatchListComponent,
    PropertyDetailsComponent,
    PropertyDataComponent,
    MarketDataComponent,
    MyPortfolioProperties,
    MarketSnapshotChartComponent,
    CreditProfileComponent,
    CreditProfileFinancialsComponent,
    CreditProfileProfileTabComponent,
    CreditProfileStatisticsComponent,
    CreditProfileSummaryComponent,
    MarketSnapshotChartComponent,
    MyPortfolioAddLeasingHistoryComponent,
    MyPortfolioAddSalesHistoryComponent,
    MyPortfolioLeasingHistoryListComponent,
    MyPortfolioPropertyHistoryRentTermComponent,
    MyPortfolioPropertyLeaseHistoryListComponent,
    MyPortfolioSaleHistoryListComponent,
    PropertyHistoryComponent,
    PortfolioFilesComponent,
    PortfolioFilesUploadComponent,
    PropertyHistoryComponent,
    MasterContactComponent,
    PortfolioContactComponent,
    PropertyContactComponent,
    PortfolioMarkettingComponent,
    PortfolioApprovalListComponent,
    QuickEditMyPortfolioComponent,
    PortfolioApprovalListComponent,
    DuediligenceComponent,
    ViewPortfolioComponent,
    PreferenceComponent,
    StandardUserAddComponent,
    StandardUserDetailsComponent,
    MyPortfolioSummaryComponent,
    AddMyportfolioPrincipalPropertyComponent,
    ImportProspects,
    SortPreview,
    ProspectPreview,
    PropertyOfferDocumentUpload,
    ProspectDetailsComponent,
    ShareOMDocumentscomponent,
    NoAccessPageComponent,
    SoldDetailsComponent,  
    PropertyHistoryRentTermComponent, // not using
    AddSalesHistoryComponent, // not using,
    AddLeasingHistoryComponent, // not using
    AddConfidentialityAgreementComponent,
    UserAssociationsComponent,
    UserExchangesComponent,
    UserOffersComponent,
    DESAssociationsComponent,
    RolePermissionsComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMultiSelectModule,
    //   BrowserModule.withServerTransition({ appId: 'serverApp' }),
    RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' }),
    // IntercomModule.forRoot({
    //   appId: 'havmav76', // from your Intercom config
    //   updateOnRouterChange: true, // will automatically run `update` on router event changes. Default: `false`
    // }),
    //   /*JsonpModule,*/
    LightboxModule,
    DataTablesModule,
    TooltipModule.forRoot(),
    //ToastyModule.forRoot(),
    // // MultiselectDropdownModule,
    /* Ng2CompleterModule.forRoot(),*/
    BrowserAnimationsModule,
    ModalModule.forRoot(),
    CollapseModule.forRoot(),
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TabsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    CarouselModule,
    SlickCarouselModule,
    //SlickModule.forRoot(),
    ModalModule.forRoot(),
    PopoverModule.forRoot(),
    SharedPipesModule,
    SharedPropertyRevisionModule,
    SharedModule,
    SharedUserProfileModule,
    SharedListingModule,
    // NgDragDropModule.forRoot(),
    FinancialSummaryModule,
    SharedDealsModule,
    ToastrModule.forRoot(),
    HighchartsChartModule,
    OrderModule,
    SharedNotesModule,
    TagInputModule,
    SharedPropertiesModule,
    RecaptchaV3Module,
    // NgxSocialShareModule,
    NgxExtendedPdfViewerModule,
    SharedUsersModule,
    // NgxCurrencyModule,
    SharedTickerModule,
    //MastersModule,
    AccordionModule.forRoot(),
    SharedMasterModule,
    NgSelectModule,
    NgxMatSelectSearchModule,
    DragDropModule,
    CdkDropListGroup,
    CdkDropList,
    CdkDrag,
    NgxCurrencyDirective,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
  ],
  exports: [RouterModule],
  providers: [
    { provide: APP_ID,  useValue: 'serverApp' },
    provideNgxMask(),
    provideClientHydration(),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: BsDatepickerConfig, useFactory: getDatepickerConfig },
    DatePipe,
    BrokerageManagerService,
    HomeService,
    ComparisonService,
    FileUploadService,
    UserManagerService,
    AuthService,
    DashboardService,
    OfferService,
    RegisterService,
    ForgotPasswordService,
    BsLocaleService,
    OpportunityService,
    AuthGuard,
    AnalyticsService,
    PermissionService,
    CommonModule,
    PropertyImportService,
    {
      provide: HighchartsChartModule,
      useFactory: () => [highchartsModules],
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: '6LeeWJoqAAAAAK4H7qf9tuqcOo9EZ7SyvZV3IQik',
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    {
      provide: TooltipConfig,
      useFactory: () => {
        const config = new TooltipConfig();
        config.triggers = 'mouseenter:mouseleave click'; // Set global triggers
        return config;
      }
    }
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}
